import { gql } from '@apollo/client';

export const INITIAL_SUBSCRIPTION = gql`
subscription SubscriptionToInitialCommand($renderer: String!) {
    subscriptionToInitialCommand(renderer: $renderer) {
        renderer
        data {
            team {
                home {
                    tricode
                    kitType
                }
                away {
                    tricode
                    kitType
                }
            }
        }
        eventId
        scenePath
    }
}`;

export const COMMAND_SUBSCRIPTION = gql`
subscription SubscriptionToCommand($renderer: String!) {
        subscriptionToCommand(renderer: $renderer) {
            renderer    
            layer
            GPI
            DataConnector    
            caption {        
                id        
                action
                mode        
                option {            
                    id            
                    value        
                }        
                data
            }
        }
    }
`;

export const RESET_RENDERER_CONNECTION = gql`subscription ResetRendererConnection($rendererId: String!) {
    resetRendererConnection(rendererId: $rendererId) {
        rendererId
        reset
    }
}`;